"use strict";
/*
*
* 1) Simple usage*:
*     <Icon icon="pencil" className="c-380 fs-50" />
*
* 2) Custom icons usage**:
*     <Icon custom icon="meeting" className="c-380 fs-50" />
*
* *Check http://getbootstrap.com/components/ for available icons;
* **Check public/css/sass/custom-glyphicon.scss for available custom icons;
*
*/

const Icon = (props) => (
  props.custom
  ? <span className={"custom-glyphicon icon-" + props.icon + " " +
        (props.className ? props.className : "")} style={props.style}></span>
  : <span className={"glyphicon glyphicon-" + props.icon + " " +
        (props.className ? props.className : "")}></span>
);

Icon.propTypes = {
  icon: React.PropTypes.string.isRequired,
  className: React.PropTypes.string,
  custom: React.PropTypes.bool,
  color: React.PropTypes.object
};

module.exports = Icon;



// WEBPACK FOOTER //
// ./app/shared/components/Icon/icon.jsx